import GroupList from '@/components/group/GroupList'
import GroupVue from '@/components/group/GroupVue'

export default [
  {
    path: '/groupes',
    name: 'GroupList',
    component: GroupList,
    meta: {
      parentName: 'Home',
      requiresAuth: true,
      needProfile: ['admin', 'manager']
    }
  },
  {
    path: '/groupes/:id',
    name: 'GroupVue',
    component: GroupVue,
    meta: {
      parentName: 'GroupList',
      requiresAuth: true,
      needProfile: ['admin', 'manager'],
      maxHeight: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/groupRouter.js